module.exports = __webpack_public_path__ + "img/kairo-logo.png";